import { DEFAULT_NAMESPACE } from 'config/i18n'
import DialogWithTitleAndButtons from 'shared/components/DialogWithTitleAndButtons'
import { Trans, useTranslation } from 'react-i18next'
import { RedText, GreenText } from './LastContactDeactivationDialog.style'

interface LastContactDeactivationDialogProps {
  open: boolean
  onClose: () => void
  contractorName: string
  onSubmit: () => void
  isLoading?: boolean
}

const LastContactDeactivationDialog = ({
  open,
  onClose,
  contractorName,
  onSubmit,
  isLoading,
}: LastContactDeactivationDialogProps) => {
  const { t } = useTranslation(DEFAULT_NAMESPACE)
  return (
    <DialogWithTitleAndButtons
      open={open}
      onClose={onClose}
      variant="wide"
      title={t('contact.lastContactDeactivation.dialog.title')}
      description={
        <Trans
          i18nKey={t('contact.lastContactDeactivation.dialog.description', {
            contractor: contractorName,
          })}
          components={{ red: <RedText />, green: <GreenText /> }}
        />
      }
      dialogButtons={{
        cancelText: t(
          'contact.lastContactDeactivation.dialog.deactivateContact'
        ),
        onCancel: onSubmit,
        onSubmit: onClose,
        submitText: t('contact.keepContact'),
        cancelButtonProps: {
          isLoading,
          variant: 'outlined',
        },
        submitButtonProps: {
          disabled: isLoading,
        },
      }}
    />
  )
}

export default LastContactDeactivationDialog
